import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=9a3ca7c8&scoped=true"
import script from "./BetaBadge.vue?vue&type=script&lang=js"
export * from "./BetaBadge.vue?vue&type=script&lang=js"
import style0 from "./BetaBadge.vue?vue&type=style&index=0&id=9a3ca7c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3ca7c8",
  null
  
)

export default component.exports